export const PATIENT_WITHOUT_MDMID = 'Patient without mdmId';
export const PATIENT_WITHOUT_ADMISSION = 'Patiente without admission';
export const UNEXPIRED_TOKEN = 'Unexpired token';
export const SCHEDULED_ADMISSION_HAS_NO_EXAM = 'Scheduled admission has no exam';
export const IS_SERVICE_UNAVAILABLE_ON_MDM = 'Is service unavailable on mdm';
export const INVALID_TOKEN = 'Invalid token';
export const CHANGE_MY_SERVICES = 'I want to change my services';
export const ERROR_CREATE_ADMISSION_VACCINE = 'Error createAdmissionVaccine';
export const COLLABORATOR_WITHOUT_FCPF = 'Collaborator without fcpf';
export const ADMISSION_WITHOUT_VISIT = 'Admission without visit';
export const IS_COLLABORATOR_FLOW = 'Is collaborator flow';
export const IRREGULAR_PHONE_NUMBER = 'Irregular phone number';
export const HAS_NO_ANY_CONTACT_NUMBER = 'Has no any contact number';
